/**
 * Shape a backend refusal reason must have for the SPA to treat it as an i18n key; anything else
 * is rendered verbatim. Segments may contain underscores (the e-Fatura refusal keys such as
 * `efatura.convert.insufficient_credit` are snake_case and some are persisted) but never hyphens.
 * Lives under `types/` because `ValidationKeyShapeGuardTests` reads this file to pin every backend
 * `*ValidationKeys` / `*ErrorKeys` constant to the same pattern, and the backend build-validation
 * path filter covers `src/types/*` but not `src/lib/*`. `scripts/check-i18n-keys.mjs` reads it too.
 */
export const I18N_KEY_PATTERN = /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z0-9_]+)+$/;
